"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValueToLocalStorage = void 0;
var setValueToLocalStorage = function (key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (error) {
        console.error(error);
    }
};
exports.setValueToLocalStorage = setValueToLocalStorage;
